const Colors = {
  black: '#000',
  white: '#fff',
  primary: '#FF7673',
  primaryDark: '#ff3c38',
  primaryLight: '#ffd6d5',
  primaryXLight: '#fff1ec',
  secondary: '#1A416B',
  secondaryDark: '#0e243c',
  secondaryLight: '#547190',
  secondaryXLight: '#bcc9d4',
  secondaryXXLight: '#e1e7f2',
  lightBlue: '#5CBECC',
  lightBluBox: '#d5eff1',
  lightBlueBg: '#eef9f9',
  lightGrey: '#9daec0',
  lightGreyBg: '#f6f8f9',
  notificationsCardBorder: '#CDD8E3',
  notificationsToReadBg: '#F5F7F9',
  notificationsHoverBg: '#E8ECF0',
};

export default Colors;
